// extracted by mini-css-extract-plugin
export var copyableItem = "_44-0";
export var underlined = "_44-1";